module.exports = __webpack_public_path__ + "static/media/2.779327f8.JPG";